// extracted by mini-css-extract-plugin
module.exports = {"content":"home_content__1n19B","banner":"home_banner__3LECn","bannerWide":"home_bannerWide__18dHx"};